import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=8df84640"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8df84640')) {
      api.createRecord('8df84640', component.options)
    } else {
      api.reload('8df84640', component.options)
    }
    module.hot.accept("./PageHeader.vue?vue&type=template&id=8df84640", function () {
      api.rerender('8df84640', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/PageHeader.vue"
export default component.exports